import { z } from 'zod/v4';
import { procedure } from '@epihub/core/src/procedure';
import { zodVisitorDB } from '../model/visitordb';

export const upsertVisitorDataProcedure = procedure({
  path: '/visitor/:visitorId' as const,

  params: z.object({
    visitorId: z.string(),
  }),

  method: 'post' as const,
  query: z.object({
    isInitialLoad: z.string().transform((v) => v === 'true').optional(),
  }),

  body: zodVisitorDB,
  headers: z.object({
    ['x-visitor-id']: z.string(),
  }),

  responses: {
    200: zodVisitorDB,
  },
});
